import { useShellTitle } from '../components/layout/ShellTitleContext';
import { MyTestimonials } from '../features/surveys';

// /me/testimonials — BP 24. A student's own testimonials, with narrow/revoke
// consent controls.
export default function MyTestimonialsPage() {
  useShellTitle('My testimonials');

  return (
    <div className="ws-page space-y-4">
      <header>
        <h1 className="text-xl font-semibold text-ws-ink">My testimonials</h1>
        <p className="mt-1 text-sm text-ws-ink-3">
          Review what you’ve submitted and narrow or withdraw consent at any time.
        </p>
      </header>
      <MyTestimonials />
    </div>
  );
}
